import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import PharmacySelector from "./Selector";
import { TPharmacy } from "types/common";
import { updatePatientCondition } from 'api/textVisit';
import { gpUpdatePatientCondition } from 'api/group';
import s from './s.module.less';

interface IProps {
    open: boolean;
    pharmacy?: TPharmacy[];
    prospectId?: number;
    onCancel: () => void;
    onUpdated: () => void;
    isGroupPractice?: boolean;
}

export default function IDUpdateDialog(props: IProps) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pharmacy, setPharmacy] = useState<TPharmacy[]>(props.pharmacy || []);

    const handleSave = async () => {
        if (!props.prospectId) {
            return;
        }
        setIsSubmitting(true);
        try {
            const saveApi = props.isGroupPractice ? gpUpdatePatientCondition : updatePatientCondition;
            await saveApi(props.prospectId, {
                pharmacy: pharmacy,
            });
            props.onUpdated();
            props.onCancel();
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        } 
    }

    const handleChange = (pharmacy: TPharmacy[]) => {   
        setPharmacy(pharmacy);
    }

    useEffect(() => {
        if (props.open) {
            setPharmacy(props.pharmacy || []);
        }
    }, [props.open]);
    return (
        <Modal
            title="Edit preferred pharmacy"
            destroyOnClose
            open={props.open}
            onCancel={props.onCancel}
            width={1000}
            okText="Save"
            onOk={handleSave}
            confirmLoading={isSubmitting}
        >
            <div className={s.box}>
                <PharmacySelector value={pharmacy || []} onChange={handleChange} />
            </div>
        </Modal>
    )
}